var map = {
	"./bg_1.png": "0f90",
	"./bg_10.png": "64db",
	"./bg_11.png": "1743",
	"./bg_12.png": "1a01",
	"./bg_13.png": "1cf6",
	"./bg_14.png": "2e78",
	"./bg_2.png": "1b7c",
	"./bg_3.png": "85e3",
	"./bg_4.png": "80b2",
	"./bg_5.png": "7a1b",
	"./bg_6.png": "64e0",
	"./bg_7.png": "ea6c",
	"./bg_8.png": "0905",
	"./bg_9.png": "74b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ee6";